import { getServiceClient } from '~/lib/api'

export type ItemContent = {
  id: number
  icon_image_url: string
  type:
    | 'coin'
    | 'gem'
    | 'tree_type'
    | 'sound'
    | 'land_skin'
    | 'game_pass'
    | 'sunshine'
  value: number
}

export type ItemType = {
  id: number
  icon_image_url: string
  item_contents: ItemContent[]
}

const cache = new Map<number, Promise<ItemType>>()

export function getItemType(id: number): Promise<ItemType> {
  const cached = cache.get(id)
  if (cached) return cached
  const promise = (async () => {
    const { client } = await getServiceClient()
    const res = await client
      .get(`delivery/item-types/${id}`)
      .json<{ item_type: ItemType }>()
    return res.item_type
  })().catch((err) => {
    cache.delete(id)
    throw err
  })
  cache.set(id, promise)
  return promise
}

export function findTreeId(itemType: ItemType): number | null {
  return (
    itemType.item_contents.find((c) => c.type === 'tree_type')?.value ?? null
  )
}
